import { ResourceType } from '@repo/api-gw-sdk';

export const COLD_TIER_SUPPORTED_RESOURCE_TYPES: ResourceType[] = [
  ResourceType.AwsS3,
];
